import { ResourceAppModule } from "@/shared/app";
import { plmApp } from "../app";
import {
  Narzedzie,
  narzedzieResource,
} from "@megarax/client/src/resources/plm";

export const narzedzieModule: ResourceAppModule = {
  app: plmApp,
  formComponent: () => import("./ItemForm.vue"),
  sheetComponent: () => import("./ItemSheet.vue"),
  listComponent: () => import("./ItemList.vue"),
  title: "Narzędiza",
  route: "narzedzie",
  itemConstructor: Narzedzie,
  resource: narzedzieResource,
};
